import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/venues/FacilitiesSection.css';

const facilitiesSection = () => {
  return (
    <section className="amenities-section">
      <Container>
        <Row className="align-items-center">
          
          {/* Left Side - Image */}
          <Col xs={12} lg={6} className="mb-5 mb-lg-0">
            <div className="amenities-image-wrapper">
              <img 
                src="https://i.pinimg.com/1200x/01/03/5a/01035a5578125bd50ef23ae69cde44cb.jpg"
                alt="Wedding Amenities" 
                className="amenities-image"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=700&h=500&fit=crop';
                }}
              />
            </div>
          </Col>

          {/* Right Side - Content */}
          <Col xs={12} lg={6}>
            <div className="amenities-content">
              
              {/* Main Heading */}
              <h2 className="amenities-main-heading">
                Amenities
              </h2>

              {/* Description */}
              <p className="amenities-description">
               Enjoy premium amenities designed to make your wedding special, including beautiful décor setups, lighting, catering, and all essential services for a perfect celebration.
              </p>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default facilitiesSection;